import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GetGoodsCategoryResponse {
    product_category_idx: number;
    category_name: string;
    category_image: string;
    wreath_option: boolean;
    union_option: boolean;
}
export const useGetGoodsCategory = (): UseQueryResult<GetGoodsCategoryResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetGoodsCategoryResponse[], Error>({
        queryKey: ["getGoodsCategory"],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_product_category}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
